
// @mui material components
import Grid from "@mui/material/Grid";
import RevenueCustomersAndOrdersStats from "components/dashboard/RevenueCustomersAndOrdersStats";
import ProductsAndCategoriesSoldStats from "components/dashboard/ProductsAndCategoriesSoldStats";
import CompleteAndCancelledOrdersStats from "components/dashboard/CompleteAndCancelledOrdersStats";
import CardRevenueAndTaxesStats from "components/dashboard/CardRevenueAndTaxesStats";
import NewCustomersStats from "components/dashboard/NewCustomersStats";
import CommonLayout from "layouts/DashboardLayout";
import { Box } from "@mui/material";
import { getPermissionsByMode } from "utilities/common";
import { getData } from "utilities/common";
import { hasSectionPermission } from "utilities/common";
// import useSocket from "../../HOC/useSocket";
// import { socket } from "../../socket";
// import { useEffect } from "react";

function Dashboard() {
  // const {isConnected} = useSocket()

  // useEffect(()=>{
  //   if(isConnected){
  //     socket.emit('message.send',{name:"vipin"})

  //     socket.on('newOrder',(data)=>{
  //     })
  //   }
  // },[isConnected])
  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canViewall = hasSectionPermission(permissionsForMode, "Dashboard", "View all charts and data points");
  const canViewRevenue = hasSectionPermission(permissionsForMode, "Dashboard", "View Revenue related charts");
  const canViewOrder = hasSectionPermission(permissionsForMode, "Dashboard", "View Orders related charts");
  const canViewProducts = hasSectionPermission(permissionsForMode, "Dashboard", "View Products related charts");
  const canDownload = hasSectionPermission(permissionsForMode, "Dashboard", "Disable download CSV option");

  return (
    <CommonLayout>
      {
        canViewall &&
        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
          <Grid container spacing={2.5}>
            <RevenueCustomersAndOrdersStats canViewall={canViewall} canViewRevenue={canViewRevenue} canViewOrder={canViewOrder} canDownload={canDownload} canViewProducts={canViewProducts}/>

            <ProductsAndCategoriesSoldStats canViewall={canViewall} canViewRevenue={canViewRevenue} canViewOrder={canViewOrder} canDownload={canDownload} canViewProducts={canViewProducts} />
            {
              canViewOrder &&
              <CompleteAndCancelledOrdersStats canViewall={canViewall} canViewRevenue={canViewRevenue} canViewOrder={canViewOrder} canDownload={canDownload}  canViewProducts={canViewProducts}/>
            }
            {
              canViewRevenue &&
              <CardRevenueAndTaxesStats canViewall={canViewall} canViewRevenue={canViewRevenue} canViewOrder={canViewOrder} canDownload={canDownload} canViewProducts={canViewProducts} />
            }

            <NewCustomersStats canViewall={canViewall} canViewRevenue={canViewRevenue} canViewOrder={canViewOrder} canDownload={canDownload}  canViewProducts={canViewProducts}/>
          </Grid>
        </Box>
      }
    </CommonLayout>
  );
}

export default Dashboard;
